import { RootState } from '../../store';
import { Participant, StoreStatus } from '../types/common.types';

export const MOCK_PARTICIPANT: Participant[] = [
  {
    participantId: '1234567890',
    participantRef: 'DMUK-0001',
    firstName: 'Ameliaz',
    surname: 'Patelz',
    dob: '1991-07-28',
    sexAtBirth: 'Female',
    nhsNumber: '4857392016',
    participantStatus: 'ACTIVE',
  },
  {
    participantId: '2345678901',
    participantRef: 'DMUK-0002',
    firstName: 'Franz',
    surname: 'Jakobs',
    dob: '1981-01-28',
    sexAtBirth: 'Male',
    nhsNumber: '4857392015',
    participantStatus: 'ACTIVE',
  },
  {
    participantId: '3456789012',
    participantRef: 'DMUK-0003',
    firstName: 'Wilma',
    surname: 'Smith',
    dob: '1971-09-03',
    sexAtBirth: 'Female',
    nhsNumber: '8573920154',
    participantStatus: 'WITHDRAWN',
  },
  {
    participantId: '4567890123',
    participantRef: 'DMUK-0004',
    firstName: 'Ivor',
    surname: 'Sample',
    dob: '1970-09-22',
    sexAtBirth: 'maLE',
    nhsNumber: '5739201548',
    participantStatus: 'ACTIVE',
    sampleBarcode: '1234567890',
  },
];

export const MOCK_ROOT_STATE: RootState = {
  participant: {
    errors: null,
    status: StoreStatus.IDLE,
    response: null,
    sampleKit: null,
    sampleLink: null,
  },
};
